import { useWidget } from '@telescope/cassini-hooks';
import { Container, Stack, IconButton, Spacer, LightMode, chakra } from '@telescope/cassini-ui';
import { Text, Link } from 'components';
import { StackDivider } from '@chakra-ui/react';
import React from 'react';

import { iconMap } from './utils';
import { Closed, Open } from 'generated-types/widget';

export const Footer = () => {
  const { data: footer } = useWidget({ select: (data: Open | Closed) => data.widget.global_views.footer });
  const { content, settings, styles } = footer!;

  if (!settings.isVisible) {
    return <Spacer p={{base: 4, lg: 12}}/>
  };

  const OneTrustButton = chakra('button');

  const TextLinks = () => (
    <Stack
      className="cassini-footer__text-links"
      wrap="wrap"
      direction={'row'}
      divider={<StackDivider borderColor="current" aria-hidden="true" />}>
      {content.links?.map((link, index: number) => {
        return (
          <Link key={index} allowMarkdown href={link.href} target="_blank" {...styles.link}>
            {link.text}
          </Link>
        );
      })}
      
      <OneTrustButton
        sx={{
          '#ot-sdk-btn&.ot-sdk-show-settings' : {
            color: styles.link.color,
            padding: '0',
            border: '0',
            fontSize: 'inherit',
            ':hover': {
              color: 'primary.300',
              bg: 'none',
              textDecoration: 'underline'
            }
          }
        }}
        id="ot-sdk-btn"
        className="ot-sdk-show-settings">Cookie Settings</OneTrustButton>
    </Stack>
  );

  const FollowLinks = () => (
    <Stack wrap="wrap" className="cassini-footer__follow-links" direction="row" fontSize={30} {...styles.followLinks}>
      {content.followLinks?.map((link, index: number) => {
        const { colorScheme, ...restStyles } = styles.followLinksIcon;
        const isMonochrome = colorScheme !== 'brand'; // if the colorScheme is 'brand', use the official brand icons, otherwise all icons will be monochrome based on the colorScheme

        return (
          <IconButton
            data-social-name={link.icon}
            className="cassini-footer__follow-links-icon"
            fontSize="inherit"
            variant="link"
            key={index}
            as="a"
            href={link.href}
            aria-label={link.alt}
            target="_blank"
            icon={React.createElement(iconMap[`${isMonochrome ? 'monochrome_' : ''}${link.icon}`])}
            colorScheme={colorScheme === 'brand' ? undefined : colorScheme}
            {...restStyles}
          />
        );
      })}
    </Stack>
  );

  return (
    <Container
      as="footer"
      className="cassini-footer"
      role="contentinfo"
      centerContent
      maxW={settings.isFullWidth ? 'full' : 'app'}
      {...styles.general}>
      <Stack
        direction="column"
        align="center"
        className="cassini-footer__container"
        spacing={6}
        py={6}
        w="100%"
        {...styles.footerContainer}>
        <TextLinks />
        <LightMode>
          <FollowLinks />
        </LightMode>
        <Text allowMarkdown fontSize="sm" color={'#fff'} sx={{...styles.copy}}>
          {content.legalText}
        </Text>
      </Stack>
    </Container>
  );
};
